import "./styles.css";
import React, { useEffect, useMemo, useState } from "react";
import discountSvg from "../../assets/images/discounts.svg";
import { useSelector, useDispatch } from "react-redux";
import C from "Constants";
import { t } from "i18next";
import { checkValidStrores } from "utils/Utils";
import { checkcouponServiceType } from "utils/Utils";
import SlideInLayout from "components/layouts/SlideInLayout";
import { copyToClipboard } from "utils/Utils";
import { Close } from "icons";
import { CustomButton } from "components/Button";
import { AllItems, AllOutlets, ChatBubbleIcon } from "./discount-icons";
import LoyaltyPopup from "./LoyaltyPopup";
import LoyaltyCard from "assets/images/loyalty-card.png"
import { TranslationText } from "components/TextTranslationContainer";
import { AppAction } from "store/actions";
import AED from "icons/AED";

const DiscountDetailsPopup = ({ discountPopup, handleClose = () => { } }) => {
  const discountInfo = discountPopup?.discount?.discount;
  const discountInfoList = useMemo(() => {
    const info = [];
    // 1. Store applicability
    info.push({
      title: discountInfo?.isApplicableOnAllStores
        ? t("Available on all outlets")
        : t("Available on selected outlets only"),
      icon: AllOutlets
    });
    // 2. Item applicability
    info.push({
      title: discountInfo?.isApplicableOnAllItems
        ? t("Applicable to all items")
        : t("Applicable to selected items"),
      icon: AllItems
    });
    // 3. Max discount value for percentage type
    if (discountInfo?.discountType === "percentage") {
      info.push({
        title: t("Discount value up to AED", {
          amount: discountInfo?.maximumDiscountValue,
        }),
        icon: ChatBubbleIcon
      });
    }
    // 4. Per customer usage (1–10 times)
    if (discountInfo?.perCustomerUse > 0 && discountInfo?.perCustomerUse <= 10) {
      info.push({
        title:
          discountInfo?.perCustomerUse === 1
            ? t("Application 1 time per user")
            : t("Applicable x time(s) per user", {
              usageLimit: discountInfo?.perCustomerUse,
            }),
        icon: ChatBubbleIcon
      });
    }
    return info;
  }, [discountInfo]);

  return (
    <SlideInLayout
      hideOutsideCloseButton={true}
      open={discountPopup?.open}
      handleClose={handleClose}
      container={{ className: "slide-in-coupun-card-popup" }}
    >
      <div className="relative p-6">
        <button className="slide-inclose-button absolute top-6 left-6 group">
          <Close
            onClick={handleClose}
            className="text-dark-blue-900 group-hover:text-brand-base-primary"
          />
        </button>
        <h2 className={`text-24x font-bold text-dark-blue-900 text-center`}>
          {t(
            discountPopup?.discount?.title +
              " (" +
              discountInfo?.discountAmount +
              ")"
          )}
        </h2>
        <div className="flex justify-between items-center mt-13">
          <p
            className={`flex-1 text-20x font-medium text-dark-blue-900 m-0 ${
              discountInfo?.discountAppliedOnSpecificItems?.length > 0
                ? "select-none line-through"
                : ""
            }`}
          >
            {t("Code")} {" : "}{" "}
            <span className="text-brand-base-primary">
              {discountInfo?.discountCode}
            </span>
          </p>
          <CustomButton
            disabled={discountInfo?.discountAppliedOnSpecificItems?.length > 0}
            onClick={() => {
              copyToClipboard(
                discountInfo?.discountCode,
                t("The COUPON code has been successfully copied")
              );
              handleClose();
            }}
            className="w-fit text-14x"
          >
            {t("Copy Code")}
          </CustomButton>
        </div>
        {discountInfo?.discountAppliedOnSpecificItems?.length > 0 && (
          <TranslationText
            text="This coupon is automatically applied to all eligible items"
            className="text-16x text-red-400 py-2"
          />
        )}
        <ul className="w-full space-y-4 mt-4">
          {discountInfoList?.map((item, index) => (
            <li
              key={index}
              className={`flex items-center gap-2 ${
                index === discountInfoList?.length - 1 ? "" : "mb-6"
              }`}
            >
              <item.icon />
              <span className="text-dark-blue-900 text-16x font-medium">
                {t(item?.title)}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </SlideInLayout>
  );
};

const Card = ({ title, description, icon, discount, textClass, descriptionValue, className = "", onClick = () => { } }) => {
  return (
    <div
      className={`discount-loyalty-container gap-5 ${className} cursor-pointer`}
      onClick={onClick}
    >
      <div className="flex flex-col gap-3 justify-end">
        <h2 className={`font-bold text-20x m-0 ms-2 leading-none break-all ${textClass ?? "text-white"}`}>{t(title)}</h2>
        {/* <p className={`text-14x font-medium m-0 leading-none ${textClass ?? "text-white"}`}>{t(description, {
          value: descriptionValue
        })}</p>  */}
        <button
          disabled={!discount}
          onClick={onClick}
          className="bg-white text-gray-800 rounded-full p-3 text-base font-medium shadow hover:bg-gray-100 transition flex flex-wrap items-center gap-1"
        >
          <span>{t("Get discount", {
            value: descriptionValue,
          })}</span>
          {
            discount?.discountType?.toLowerCase() === "percentage" ? (
              <span>%</span>
            ) : (
              <AED width={12} height={12} />
            )
          }
          <span>{t("off")}</span>
        </button>
      </div>
      <img src={icon ?? discountSvg} alt={title} className="w-28 h-28" />
    </div>
  );
};

const DiscountsAndLoyalty = ({ selectedStore }) => {
  const { discounts } = useSelector((state) => state?.brand);
  const { loyaltyPolicy } = useSelector((state) => state?.brandStorageReducer);
  const { orderType } = useSelector((state) => state.AppReducer);
  const { isAlreadyShowedWelcomeCouponModal } = useSelector((state) => state.AppReducer);
  const dispatch = useDispatch();
  const [discountPopup, setDiscountPopup] = useState({
    open: false,
    discount: null,
  });

  const [loyaltyPopup, setLoyaltyPopup] = useState({
    open: false,
    loyaltyPolicy: null,
  });

  const discountsCards = useMemo(() => {
    const visibleDiscounts = [];
    // discounts?.sort((a, b) => {
    //   return b?.discountAppliedOnSpecificItems?.length - a?.discountAppliedOnSpecificItems?.length;
    // });
    discounts?.forEach((discount, index) => {
      if (
        checkValidStrores(discount, selectedStore) &&
        checkcouponServiceType(discount, orderType) &&
        discount?.discountApplication !== C.COUPUN_APPLICATION_TYPE.HIDDEN
      ) {
        visibleDiscounts.push({
          id: discount?._id,
          className:
            index % 2 == 0 ? "welcome-discount-card" : "discount-coupun-card",
          title: discount?.discountName,
          description:
            discount?.discountType?.toLowerCase() === "percentage"
              ? `% off`
              : `AED off`,
          descriptionValue: discount?.discountAmount,
          discount: discount,
          icon: discountSvg,
          textClass: index % 2 == 0 ? "text-white" : "text-black",
        });
      }
    });

    return visibleDiscounts;
  }, [discounts]);


  useEffect(() => {
    if(discountsCards?.length>0 && !isAlreadyShowedWelcomeCouponModal){
      let discount = discountsCards?.find((discount) => discount?.discount?.isApplicableOnAllItems);
      if(!discount){
        discount = discountsCards?.[0];
      }
      setDiscountPopup({ open: true, discount: discount });
      dispatch(AppAction.setIsAlreadyShowedWelcomeCouponModal(true));
    };
  }, [discountsCards]);

  const handleClose = () => {
    setDiscountPopup({ open: false, discount: null });
  }

  return (
    <>
      <div className="coupon-sec flex flex-col">
        <div className={`grid grid-flow-col gap-4 px-6 pt-5 overflow-x-auto ${discountsCards?.length > 0 && loyaltyPolicy?.isLoyaltyActive ? "pb-5" : "pb-0"}`}>
          {discountsCards?.map((discount) => (  
            <Card
              key={discount?.id}
              {...discount}
              onClick={() =>
                setDiscountPopup({ open: true, discount: discount })
              }
            />
          ))}
          {loyaltyPolicy?.isLoyaltyActive && (
            <Card
              title={"Loyalty Credit"}
              className="loyalty-card"
              description={`Earn in cashback to spend in your next orders`}
              descriptionValue={loyaltyPolicy?.redeemablePercentagePerOrder}
              discount={loyaltyPolicy}
              textClass="text-black"
              icon={LoyaltyCard}
              onClick={() => {
                setLoyaltyPopup({ open: true, loyaltyPolicy: loyaltyPolicy });
              }}
            />
          )}
        </div>

      </div>
      <DiscountDetailsPopup
        discountPopup={discountPopup}
        handleClose={handleClose}
      />
      <LoyaltyPopup
        open={loyaltyPopup?.open}
        loyaltyPolicy={loyaltyPopup?.loyaltyPolicy}
        handleClose={() => setLoyaltyPopup({ open: false, loyaltyPolicy: null })}
      />
    </>
  );
};

export default DiscountsAndLoyalty;
